<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row>
          <Col span="19">
            <Button type="primary" @click="modal1=true">增加</Button>
          </Col>
          <Col span="5">
             <Input search enter-button placeholder="输入关键词搜索" v-model="serch.key"  @on-search="load"/>
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" style="width: 100%" >
        <el-table-column prop="id" label="编号" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="name" label="角色名称" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="note" label="备注" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="count" label="权限数量" :show-tooltip-when-overflow="true"></el-table-column>

        <el-table-column prop="msg" label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <a @click="open2(scope.row.id)">分配权限</a>
            <cite>|</cite>
            <a @click="edit(scope.row.id)">编辑</a>
            <cite>|</cite>
            <a @click="remove(scope.row.id)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save">
      <Form :label-width="80">
				<FormItem label="角色名称">
					<Input v-model="detail.name"/>
				</FormItem>
				<FormItem label="备注">
					<Input v-model="detail.note"/>
				</FormItem>

      </Form>
    </Modal>

    <Drawer v-model="m2.modal" width="500" title="权限分配" :styles="styles">
      <b>已选择{{m2.checks.length}}个权限</b>

      <CheckboxGroup v-model="m2.checks">
        <div  v-for="item in m2.list" style="line-height: 30px;">
          <Checkbox :label="item.id">
            {{ item.name }}
            <span style="color: orange">&nbsp;P{{item.id}}</span>
          </Checkbox>
        </div>
      </CheckboxGroup>

      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="m2.modal = false">取消</Button>
        <Button type="primary" @click="submit" :loading="m2.loading">提交</Button>
      </div>
    </Drawer>

  </div>
</template>

<script>
  export default {
    data(){
      return{
        baseUrl:'/api/power/powerrole/',
        list:[],
        page:1,
        count:0,
        limit:10,
        modal1:false,
        detail:{},
        serch:{
          key:''
        },
        loading:false,
        m2:{
          list:[],
          modal:false,
          checks:[],
          roldId:0,
          loading:false,
        },
        styles: {
          height: 'calc(100% - 55px)',
          overflow: 'auto',
          paddingBottom: '53px',
          position: 'static'
        },
      }
    },
    methods:{
      submit(){
        let that = this;
        this.$axios({url:this.baseUrl+'submit?roleId='+this.m2.roldId+'&list='+this.m2.checks,method:'post',data:{}}).then(function(rs){
          that.toast(rs.data);
          that.m2.loading = false;
          if(rs.data.success){
            that.m2.modal = false;
          }
        });
      },
      open2(id){
        this.$Spin.show();
        this.m2.roldId = id;
        let that = this;
        this.$axios.get(this.baseUrl+'getRoleList?roleId='+this.m2.roldId).then(function(rs){
          that.m2.checks = rs.data;
          that.m2.modal = true;
          that.$Spin.hide();
        });
      },
      load(){
        let that = this;
        let params = [];
        if(this.serch.key){
          params.push('t.id@=@'+this.serch.key);
        }
        that.loading = true;
        this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='+this.limit+'&params='+params).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(){
        let that = this;
        let data = Object.assign({}, this.detail);
        this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {};
          }
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          that.modal1 = true;
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      },
      loadAll(){//查询所有权限列表
        let that = this;
        this.$axios.get('/api/power/powerlist/findall?page=1&limit=10000').then(function(rs){
          that.m2.list = rs.data.data;
        });

      },
    },
    created(){
      this.loadAll();
      this.load();
    }
  }
</script>


<style>
.demo-drawer-footer{
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/power/PowerRole.vue